<div class="failure-main-container">

  <div class="card-container">

    <img src="./assets/img/logo/openpay.webp"
         srcset="./assets/img/logo/openpay@2x.webp 2x,
             ./assets/img/logo/openpay@3x.webp 3x"
         class="openpay-logo"
         alt="openpay logo"
    >

    <div class="failure-container">
      <img src="./assets/img/failure/failure.png"
           srcset="./assets/img/failure/failure@2x.png 2x,
             ./assets/img/failure/failure@3x.png 3x"
           class="failure-check"
           alt="openpay logo"
      >
    </div>

    <span class="failure-title">
      {{errorTitle}}
    </span>

    <div class="failure-content">
      {{errorMessage}}
      <p><span class="go-back-hyperlink" (click)="goToCallbackUrl()">{{errorButtonCta}}</span></p>
    </div>

  </div>

</div>
